export const apiCreate = (): string => '/partnerships/agenciesUsers/'
export const apiList = (id?: string): string =>
  !id
    ? '/partnerships/agenciesUsers/'
    : `/partnerships/agenciesUsers/view/${id}`
export const apiGetByIdUpdatePage = (id: string): string =>
  `/partnerships/agenciesUsers/getByIdUpdatePage/${id}`
export const apiUpdate = (id: string): string =>
  `/partnerships/agenciesUsers/update/${id}`
export const apiDelete = (id: string): string =>
  `/partnerships/agenciesUsers/${id}`
